import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController } from "@ionic/angular";
import { Subscription } from 'rxjs';
import { EnvironmentSearchComponent } from 'src/components/general components/environment-search/environment-search.component';
import { EventService } from 'src/service/event.service';

@Component({
    selector: 'app-popup-device-creation',
    templateUrl: './popup-device-creation.component.html',
    styleUrls: ['./popup-device-creation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupDeviceCreationComponent implements OnInit {
  public _eventSubscriptions: Array<Subscription> = null;
  private _idEnvironmentSelected: number = 0;
  public formCreateDevice: UntypedFormGroup = null;

  constructor (
    private _fb: UntypedFormBuilder,
    private _modalController: ModalController,
    private _eventService: EventService
  ) { }

  ngOnInit() {
    this.initializeForm();
    this.subscribeEvents();
  }

  ngOnDestroy(): void {
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._modalController.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  /**
   * Close button: dismisses without data, the same result as a tap on the backdrop
   */
  public onClickClose(): void {
    this._modalController.dismiss();
  }

  /**
   * Handle click save button
   */
  public async onClickSave(): Promise<void> {
    this.formCreateDevice.value.idEnvironment = this._idEnvironmentSelected;
    await this._modalController.dismiss(this.formCreateDevice.value);
  }

   /**
   * On click search environment load the environment that we want to associate
   */
    async onClickSearchEnvironment() {
      const modalSearchEnvironment = await this._modalController.create({
        component: EnvironmentSearchComponent,
        cssClass: "modal-bigger",
      });
  
      modalSearchEnvironment.present();
  
      const { data } = await modalSearchEnvironment.onDidDismiss();
  
      if (modalSearchEnvironment) {
        modalSearchEnvironment.dismiss();
      }
  
      if (data) {        
        this._idEnvironmentSelected = data.id;
        this.formCreateDevice.patchValue({
          idEnvironment: data.name,
        });
      }
    }
  


  /**
   * Initialize form data //
   */
  private initializeForm(): void {
    this.formCreateDevice = this._fb.group(
      {
        physicalAddress: new UntypedFormControl('',[Validators.required]),
        description: new UntypedFormControl('', [Validators.required]),
        idEnvironment: new UntypedFormControl('', [Validators.required]),
      }
    );
  }
}
